// src/components/inputs/MultiImageUploader/ImageGridDisplay.jsx

import React from "react";
import { Grid } from "@mui/material";
import UploadedImageCard from "./UploadedImageCard";
import UploadingImageCard from "./UploadingImageCard";

const ImageGridDisplay = ({
    value,
    uploadQueue,
    uploadingImages,
    errors,
    isArabic,
    isDark,
    onDeleteImage,
    onRetry,
    onRemoveFromQueue,
}) => {
    return (
        <Grid container spacing={2}>
            {/* Uploaded images */}
            {value.map((image, index) => (
                <Grid item xs={12} sm={6} md={4} key={image.file_name || index}>
                    <UploadedImageCard
                        image={image}
                        index={index}
                        isArabic={isArabic}
                        isDark={isDark}
                        onDelete={() => onDeleteImage(image, index)}
                    />
                </Grid>
            ))}

            {/* Uploading images */}
            {uploadQueue.map((item) => (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                    <UploadingImageCard
                        item={item}
                        tempId={item.id}
                        status={uploadingImages[item.id]}
                        error={errors[item.id]}
                        isArabic={isArabic}
                        isDark={isDark}
                        onRemove={() => onRemoveFromQueue(item.id)}
                        onRetry={() => onRetry(item.id)}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default ImageGridDisplay;
